import { createContext, createRef } from 'react';
// import { DSTabsDefaultProps as defaultProps } from './react-desc-prop-types.js';
import type { DSTabsInternalsT } from './sharedTypes.js';

// eslint-disable-next-line @typescript-eslint/no-empty-function
// const noop = () => {};

// const defaultContext = {
//   props: defaultProps,
//   tabsRef: createRef<Record<number, HTMLButtonElement> | null>(),
//   tabsListRef: createRef<HTMLDivElement | null>(),
//   carouselOnlyListRef: createRef<HTMLDivElement | null>(),
//   focusableTabsRef: createRef<HTMLButtonElement[] | null>(),
//   tabsRefAsArray: createRef<HTMLButtonElement[] | null>(),
//   actualActiveTabRef: createRef<HTMLButtonElement | null>(),
//   userDidChangeTabAtleastOnceRef: createRef<{ current: boolean }>(false),
//   setInternalActiveTab: noop,
//   actualActiveTab: '',
//   globalClickHandler: noop,
//   updateIndicatorStyle: noop,
//   updateMobileGradients: noop,
//   setIndicatorStyle: noop,
//   indicatorStyle: { left: 0, width: 0 },
//   mobileGradients: { right: false, left: false },
// } as DSTabsInternalsT.DSTabsUseTabsContextT;

const defaultCrossRefsContext = {
  lastTabInternalRef: createRef<HTMLButtonElement | null>(),
  firstSubtabInternalRef: createRef<HTMLButtonElement | null>(),
};

export const DSTabsContext = createContext<DSTabsInternalsT.DSTabsUseTabsContextT>(
  {} as unknown as DSTabsInternalsT.DSTabsUseTabsContextT,
);
export const DSTabsCrossRefContext = createContext<DSTabsInternalsT.DSTabsUseCrossRefContextT>(defaultCrossRefsContext);
